import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=f9f59e0a&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=f9f59e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f59e0a",
  null
  
)

export default component.exports